export enum QuarantinePointType {
  POINT_TYPE_TRANSPORT = 0,
  POINT_TYPE_MAILBOX = 1,
  POINT_TYPE_FOLDER = 2,
  POINT_TYPE_ONDEMAND = 3,
}

export function convertIntToPointType(value) {
  switch (value) {
    case QuarantinePointType.POINT_TYPE_ONDEMAND:
    case QuarantinePointType.POINT_TYPE_FOLDER:
      return 'Public Folder';
    case QuarantinePointType.POINT_TYPE_MAILBOX:
      return 'Mailbox';
    case QuarantinePointType.POINT_TYPE_TRANSPORT:
      return 'Transport';
    default:
      return '';
  }
}
